import React from 'react';
import { ShieldCheckIcon, ClockIcon, EyeIcon, TruckIcon, BadgeCheckIcon, CreditCardIcon } from 'lucide-react';
export const SocialProof = () => {
  return <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-1248">
      <div className="flex flex-wrap gap-4 justify-between" data-id="element-1249">
        <div className="flex items-center" data-id="element-1250">
          <EyeIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-1251" />
          <span className="text-sm text-gray-600" data-id="element-1252">
            3 people viewing this now
          </span>
        </div>
        <div className="flex items-center" data-id="element-1253">
          <ClockIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-1254" />
          <span className="text-sm text-gray-600" data-id="element-1255">
            4 people bought this in the last hour
          </span>
        </div>
        <div className="flex items-center" data-id="element-1256">
          <BadgeCheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-1257" />
          <span className="text-sm font-medium text-green-700" data-id="element-1258">
            Only 5 left in stock
          </span>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-y-2 gap-x-6" data-id="element-1259">
        <div className="flex items-center" data-id="element-1260">
          <ShieldCheckIcon className="h-5 w-5 text-gray-600 mr-2" data-id="element-1261" />
          <span className="text-sm text-gray-600" data-id="element-1262">30-Day Money Back</span>
        </div>
        <div className="flex items-center" data-id="element-1263">
          <TruckIcon className="h-5 w-5 text-gray-600 mr-2" data-id="element-1264" />
          <span className="text-sm text-gray-600" data-id="element-1265">Free Shipping</span>
        </div>
        <div className="flex items-center" data-id="element-1266">
          <CreditCardIcon className="h-5 w-5 text-gray-600 mr-2" data-id="element-1267" />
          <span className="text-sm text-gray-600" data-id="element-1268">100% Secure Payment</span>
        </div>
      </div>
      <div className="mt-4 border-t border-gray-200 pt-4 flex items-center justify-center" data-id="element-1269">
        <div className="flex items-center space-x-2" data-id="element-1270">
          <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-6" data-id="element-1271" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6" data-id="element-1272" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-6" data-id="element-1273" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg" alt="Apple Pay" className="h-5" data-id="element-1274" />
        </div>
      </div>
    </div>;
};